import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import { Row, Col, Button } from 'react-bootstrap';

function StatementExpenELe() {
    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="I-STEM" />
            <section id="services" className="team-area fix p-relative pt-50 pb-50">
                <div className="container">
                    <div className="row">
                    <div className="col-md-12 p-relative c-lineheight2">
                            <div className="row">
                                <div className="col-md-12 text-center">
                                <h1 className='c-heading pb-30'>I-STEM @ IIT Tirupati</h1>
                                    <img src="https://files.iittp.ac.in/pics/i-stem-logo.png" class="pb-30"  />
                                </div>


                                <div className="col-md-12">
                                    <div className="section-title center-align mb-20 text-left wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                                    <ul className='ms-3 c-lineheight2dot5 iarrow caboutus' >
                                    <li><Link className='c-link' to="https://www.istem.gov.in/" target="_blank"><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Click here to visit I-STEM portal</Link></li>
                                    <li><Link className='c-link' to="https://www.istem.gov.in/whatsnew_detail/15" target="_blank"><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Guidelines for booking through I-STEM</Link></li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> For more information/communication please write to (Email ID will be update soon..)</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> List of instruments available under I-STEM at IIT Tirupati.</li>
                                </ul>
                                        
                                    </div>
                                </div>

                            </div>


                        </div>

                        

                        <Col md={12} className='c-right'>

                        <div className="table-responsive">
                        {/* <Link className='c-link' to="/independent-external-monitors-iems" target="_blank">Independent External Monitors (IEMs)</Link> */}

                            <table className="table table-striped">
                                <tbody>
                                    <tr className='c-tablehead'>
                                       <th>Name of the Departement</th>
                                       <th>Equipment Name</th>
                                       <th>I-STEM Page Link</th>
                                    </tr>
                                    <tr>
                                        <td>Chemical Engineering</td>
                                        <td>Foam Analyser-Kruss-DFA100</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/45011/Foam-Analyzer" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Chemical Engineering</td>
                                        <td>Chemisorption Unit-Anton Paar-Chem BET Pulsar TPR/TPD</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/45013/Chemisorption-Analyser" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Chemical Engineering</td>
                                        <td>GC-MS-Agilent-5977B GC/MSD</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/37816/Gas-Chromatography-Mass-Spectrometry--GCMS-" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Chemical Engineering</td>
                                        <td>HPLC-Agilent-1260 Infinity II</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/37815/High-Performance-Liquid-Chromatography--HPLC-" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Chemical Engineering</td>
                                        <td>Gel Permeation Chromatography-Malvern Panalyticals-OMNISEC</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/44905/Gel-Permeation-Chromatography-" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Chemical Engineering</td>
                                        <td>UV-Visible Spectrometer-Agilent-Carry 60</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/45010/UV-Visible-Spectrophotometer" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Chemical Engineering</td>
                                        <td>Polarimeter-Anton Paar-MCP 100</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/45012/Polarimeter" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Chemical Engineering</td>
                                        <td>Nanodrop spectrophotometer - Thermo scientific - Nanodrop lite plus</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/44921/Nanodrop-spectrophotometer" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Chemistry</td>
                                        <td>UV-VIS-NIR Spectrophotometer</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/36718/UV-VIS-NIR-Spectrophotometer" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Chemistry</td>
                                        <td>FT - IR</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/36719/FT-IR-WITH-ATR" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Chemistry</td>
                                        <td>TGA – 8000 (PerkinElmer)</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/37622/Thermogravimetric-Analysis--TGA-" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Chemistry</td>
                                        <td>Fluorescence (FL-6500 (PerkinElmer))</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/37624/Fluorescence-Spectrophotometer" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Chemistry</td>
                                        <td>High Performance Liquid Chromatography (HPLC)WATERS – e2695</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/37625/High-Performance-Liquid-Chromatography--HPLC-" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Chemistry</td>
                                        <td>Electrochemical Workstation – Autolab</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/37628/Electrochemical-Workstation" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Chemistry</td>
                                        <td>Lyophilizer – Lark (Penguin Classic)</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/37769/Lyophilizer-Freeze-Dryer" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Chemistry</td>
                                        <td>Fluorescent Microscope Nikon-Ti2e</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/37629/Fluorescent-Microscope" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Chemistry</td>
                                        <td>GelDoc – Bio Rad</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/37631/Gel-Doc" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Chemistry</td>
                                        <td>NMR -Bruker (400 MHz)</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/40050/NMR-400-MHz" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Chemistry</td>
                                        <td>HRMS-Agilent 6545 LC/Q-TOF</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/38474/High-Resolution-Mass-Spectrometer--HRMS-" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Chemistry</td>
                                        <td>GC-MS -Agilent 8890</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/38475/GCMS-" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Civil & Environmental Engineering</td>
                                        <td>Inductively Coupled Plasma Mass Spectrometry (ICP-MS)</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/26530/Inductively-Coupled-Plasma-Mass-Spectrometer--ICP-MS-" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Civil & Environmental Engineering</td>
                                        <td>Microwave Digestion Unit</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/26531/Microwave-Digestion-Unit" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Civil & Environmental Engineering</td>
                                        <td>HPLC</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/26532/High-Performance-Liquid-Chromotography--HPLC-" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Civil & Environmental Engineering</td>
                                        <td>Ion Chromotography</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/26533/Ion-Chromotography" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Civil & Environmental Engineering</td>
                                        <td>UV-VIS Spectrophotometer</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/26534/UV-VIS-Spectrophotometer" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Civil & Environmental Engineering</td>
                                        <td>Advanced Hydrological Investigations</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/26554/Advanced-Hydrological-Investigations" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Civil & Environmental Engineering</td>
                                        <td>2000kN CTM</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/26538/2000-kN-Compression-Testing-Machine" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Civil & Environmental Engineering</td>
                                        <td>100kN- UTM</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/26546/100-kN-Servo-Hydraulic-Universal-Testing-Machine" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Civil & Environmental Engineering</td>
                                        <td>1200kN -UTM</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/26547/1200-kN-Electro-Machanical-Universal-Testing-Machine" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Civil & Environmental Engineering</td>
                                        <td>5kN Actuator</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/26548/5kN-Electro-Machanical-Universal-Testing-Machine" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Mechanical Engineering</td>
                                        <td>Digital height gauge</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/26585/Digital-Height-Gauge" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Mechanical Engineering</td>
                                        <td>Probe Sonicator</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/26586/Probe-Sonicator" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Mechanical Engineering</td>
                                        <td>Bomb Calorimeter</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/26587/Bomb-Calorimeter" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Mechanical Engineering</td>
                                        <td>Particle Image Velocimetry</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/26588/Particle-Image-Velocimetry" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Mechanical Engineering</td>
                                        <td>Schlieren</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/26589/Schlieren" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Mechanical Engineering</td>
                                        <td>Rheometer</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/26590/Rheometer" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Mechanical Engineering</td>
                                        <td>Spraymate spray dryer</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/26591/Spraymate-Spray-Dryer" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Mechanical Engineering</td>
                                        <td>CNC Wire cut EDM</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/26593/CNC-Wire-Cut-EDM" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Mechanical Engineering</td>
                                        <td>Co-Ordinate Measuring Machine</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/26594/Coordinate-Measuring-Machine" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Mechanical Engineering</td>
                                        <td>3D-Printer</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/26595/3D-Printer" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Mechanical Engineering</td>
                                        <td>3D- Scanner</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/26596/3D-Scanner" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Mechanical Engineering</td>
                                        <td>Surface Roughness tester</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/26597/Surface-Roughness-Tester" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Mechanical Engineering</td>
                                        <td>Stereo Microscope</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/26598/Stereo-Microscope" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Mechanical Engineering</td>
                                        <td>Metallurgical Microscope</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/26599/Metallurgical-Microscope" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Mechanical Engineering</td>
                                        <td>Digital height gauge</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/26585/Digital-Height-Gauge" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Mechanical Engineering</td>
                                        <td>CNC Turning</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/26610/CNC-Turning" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Mechanical Engineering</td>
                                        <td>CNC Milling</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/26611/CNC-Milling" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Mechanical Engineering</td>
                                        <td>Robotic GMAW setup</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/26609/Robotic-Gas-Metal-Arc-Welding-Setup" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Mechanical Engineering</td>
                                        <td>Hot/Cold Wire Tungsten Inert Gas Welding Set Up</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/26608/Hot-Cold-Wire-Tungsten-Inert-Gas-Welding-Set-Up" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Physics</td>
                                        <td>Bentch Top X-Ray Diffraction</td>
                                        <td><Link className='c-link' to="https://www.istem.gov.in/equipment-info/37775/XRD-Analysis" target="_blank">I-STEM link</Link>
                                        </td>
                                    </tr>
                                    
                                                                    
                                </tbody>
                            </table>

                        </div>

                </Col>

            </div>  {/* Row */}


        </div > {/* container */ }

            </section >
        </>
    )
}

export default StatementExpenELe;
